import { useMemo } from 'react'
import { useQuery } from "@tanstack/react-query";
import apiCall from "../utils/apiCall";

interface RouteResponse {
  StatusCode: number;
  Message: string;
  Data: RouteData[];
}

interface RouteData {
  RouteName: string;
  RouteId: number;
  Status: boolean;
  StateDate: string;
  EndDate: string;
}

 export default function FetchRoute() {
    const getAllRoute = async (): Promise<RouteResponse> => {
      return (await apiCall().get(`Routes/GetAllRoute`)).data;
    }

    const { data, isLoading, isError, error} = useQuery(['get-allroutes'], getAllRoute, {
        enabled: true,
        keepPreviousData: true,
        retry: 0,
    })

    const memoData = useMemo(() => {
      return { data, isError, isLoading, error}
    }, [data])

    return { memoData }
    
}

